const SERVICE = 'market/customer';

const product = async (api, uuid) =>
  api.setMethod().get().setService(SERVICE).process(`/catalogue/${uuid}`);

const productsList = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process('/catalogue', params);

const searchList = async (api, params) =>
  api.setService(SERVICE).client.request({
    method: 'GET',

    url: api.service + '/catalogue/',
    params,
    headers: {
      ...api.optionsObject.headers,
    },
  });
const packageSearchList = async (api, params) =>
  api.setService(SERVICE).client.request({
    method: 'GET',
    url: `${api.service}/catalogue?mode=2&_search=${params}`,
    headers: {
      ...api.optionsObject.headers,
    },
  });

const productSearchList = async (api, params) =>
  api.setService(SERVICE).client.request({
    method: 'GET',

    url: `${api.service}/catalogue?mode=1&${params}`,
    headers: {
      ...api.optionsObject.headers,
    },
  });
const newProducts = async (api, params) =>
  api.setMethod().get().setService(SERVICE).process('/catalogue/new', params);

const particularProducts = async (api, uuid) =>
  api.setMethod().get().setService(SERVICE).process(`/catalogue/${uuid}`);

const productCategory = async (api, params) => 
  
    //api.setMethod().get().setService(SERVICE).process(`/catalogue`, params);
    api.setService(SERVICE).client.request({
      method: 'GET',

      url: api.service + '/catalogue/',
      params,
      headers: {
        ...api.optionsObject.headers,
      },
    })

// api
//   .setMethod()
//   .get()
//   .setService(SERVICE)
//   .process(
//     `/catalogue?mode=1&_page=5&_pagesize=20&filters=is_available%3A%22true%22&type%22product_category:%22Personal+Care%22`
//   );

const storeDetails = async (api) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process('/catalogue/store/b2c-store-8m');
const storeProductsList = async (api, params) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process('/catalogue/store/b2c-store-8m/product', params);

module.exports = {
  product,
  productsList,
  searchList,
  newProducts,
  particularProducts,
  storeDetails,
  packageSearchList,
  productCategory,
  productSearchList,
  storeProductsList,
};
